
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers-news/page/[page]",
      function () {
        return require("private-next-pages/employers-news/page/[page].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers-news/page/[page]"])
      });
    }
  